import React from 'react';
import { UrgencyBadge } from '../ui/urgency-badge';

/**
 * SLA timer pill — counts down from a 48h window starting at `draftSavedAt`.
 * Maps onto the platform's urgency hierarchy:
 *   • overdue or <6h remaining → critical (red)
 *   • <18h remaining           → warning  (amber)
 *   • otherwise                → neutral
 */
export default function SlaTimer({ draftSavedAt, hoursWindow = 48 }) {
  const start = new Date(draftSavedAt).getTime();
  const deadline = start + hoursWindow * 60 * 60 * 1000;
  const now = Date.now();
  const remainingMs = deadline - now;
  const overdue = remainingMs <= 0;

  const hoursLeft = Math.max(0, Math.floor(remainingMs / (60 * 60 * 1000)));
  const minutesLeft = Math.max(0, Math.floor((remainingMs % (60 * 60 * 1000)) / (60 * 1000)));

  let level = 'neutral';
  let label;
  if (overdue) {
    level = 'critical';
    label = 'SLA overdue';
  } else if (remainingMs < 6 * 60 * 60 * 1000) {
    level = 'critical';
    label = hoursLeft >= 1 ? `${hoursLeft}h ${minutesLeft}m left` : `${minutesLeft}m left`;
  } else if (remainingMs < 18 * 60 * 60 * 1000) {
    level = 'warning';
    label = `${hoursLeft}h left`;
  } else {
    label = `${hoursLeft}h left`;
  }

  return <UrgencyBadge level={level} label={label} testId="draft-sla-timer" />;
}
